import { c as _c } from "react/compiler-runtime";
import { SvgChevronright, SvgDelete } from '@common/icon';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import giftHeartImage from './_assets/gift-heart.png';
const themeStyles = {
  white: {
    container: 'bg-Gray-white bg-opacity-100',
    title: 'text-B-400',
    subtitle: 'text-Gray-700',
    closeButton: 'text-Gray-600'
  },
  black: {
    container: 'bg-Gray-black bg-opacity-70',
    title: 'text-Gray-white',
    subtitle: 'text-B-300',
    closeButton: 'text-Gray-400'
  }
};
export interface DonationBenefitToastProps {
  onClose?: () => void;
  theme: 'white' | 'black';
  href?: string;
}
interface CloseButtonProps {
  onClose?: () => void;
  theme: 'white' | 'black';
}
interface ContentProps {
  theme: 'white' | 'black';
  href?: string;
}
const CloseButton = t0 => {
  const $ = _c(6);
  const {
    onClose,
    theme
  } = t0;
  const t1 = themeStyles[theme];
  let t2;
  if ($[0] !== t1.closeButton) {
    t2 = cn("absolute inset-y-0 right-0 z-50 flex w-50 items-center justify-center", t1.closeButton);
    $[0] = t1.closeButton;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgDelete className="size-14" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClose || $[4] !== t2) {
    t4 = <button type="button" aria-label={"\uB2EB\uAE30"} onClick={onClose} className={t2}>{t3}</button>;
    $[3] = onClose;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
const Content = t0 => {
  const $ = _c(16);
  const {
    theme,
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image alt={"\uC120\uBB3C"} height={34} src={giftHeartImage.src} width={34} className="size-34 shrink-0" unoptimized={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = themeStyles[theme];
  let t3;
  if ($[1] !== t2.title) {
    t3 = cn("whitespace-nowrap", t2.title);
    $[1] = t2.title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <p className={t3}>10만원 기부 → 10만원 모두 세액공제!</p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = themeStyles[theme];
  let t6;
  if ($[5] !== t5.subtitle) {
    t6 = <p className={t5.subtitle}>기부하시고 답례품도 받으세요!</p>;
    $[5] = t5.subtitle;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4 || $[8] !== t6) {
    t7 = <div className="font-500 typo-body4">{t4}{t6}</div>;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== href || $[11] !== theme) {
    t8 = href ? <div className="absolute inset-y-0 right-0 flex w-50 items-center justify-center"><SvgChevronright className={cn("size-16", themeStyles[theme].closeButton)} /></div> : null;
    $[10] = href;
    $[11] = theme;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <>{t1}{t7}{t8}</>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export const DonationBenefitToast = t0 => {
  const $ = _c(9);
  const {
    onClose,
    theme,
    href
  } = t0;
  const currentTheme = themeStyles[theme];
  let t1;
  if ($[0] !== currentTheme.container) {
    t1 = cn("pointer-events-auto relative flex items-center gap-8 rounded-pill py-16 pl-32 pr-48 backdrop-blur-lg", currentTheme.container);
    $[0] = currentTheme.container;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== href || $[3] !== onClose || $[4] !== theme) {
    t2 = href ? <CustomLink href={href} className="flex items-center gap-8"><Content theme={theme} href={href} /></CustomLink> : <><Content theme={theme} /><CloseButton onClose={onClose} theme={theme} /></>;
    $[2] = href;
    $[3] = onClose;
    $[4] = theme;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};